




































import { Component, Prop, Vue } from "vue-property-decorator";
import { IUserNotification } from "@/models/userNotifications";

/**
 * IMPORTANT: this component is used as mixin for `src/plugins/UNotification/UNotification.vue`
 * please if you change something make sure that the notification popup is working.
 * Not the native browser one, but the one that we fire when the user
 * haven not enabled the native notifications.
 */
@Component
export default class UserNotification extends Vue {
  // Props
  @Prop({ required: true })
  public userNotification!: IUserNotification;
  // Data
  public charLimit = 150;
  public readMore = false;
  // Getters
  public get status() {
    return this.userNotification.status;
  }
  public get subject() {
    return this.userNotification.subject;
  }
  public get notificationMessage() {
    return this.$_.get(this.userNotification, "message");
  }
  public get hasMoreBody() {
    return this.notificationMessage.length > this.charLimit && !this.readMore;
  }
  public get body() {
    if (!this.hasMoreBody) return this.notificationMessage;
    return `${this.notificationMessage.substr(
      0,
      this.notificationMessage.lastIndexOf(" ", this.charLimit)
    )}... `;
  }
  public get dateCreated() {
    return this.$_.get(this.userNotification, "created_at");
  }
}
